import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component({})
export default class FeatureLimit extends Vue {
  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;

  @appStoreState.Mutation
  public setIsShowFeatureLimit!: (payload: boolean) => void;

  @appStoreState.Getter
  public getIsShowFeatureLimit!: boolean;

  mounted() {}

  close() {
    this.setIsShowFeatureLimit(false);
  }

  routeToPlanPricing() {
    this.$router.push('/pricing-plan');
    this.close();
  }
}
